'use strict';
import $ from 'jquery';
const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/; // eslint-disable-line no-control-regex

$(document).ready(function () {
    const input = $('.footer__subscribe-input');
    validateEmail(input);
    input.on('change paste keyup', function () {
        validateEmail($(this));
    });
});

function validateEmail (self) {
    const form = self.closest('form');
    const btn = form.find('.footer__subscribe-btn');

    if (regex.test(String(self.val()).toLowerCase())) {
        self.addClass('valid');

        btn.prop('disabled', false);
    } else {
        self.removeClass('valid');
        btn.prop('disabled', true);
    }
}
